import request from '@/utils/request'
import { decorType } from '@/utils/decor-types'
import { api } from '~/ui-domain'

/** 查询当前装修主体可配置的优惠券。 */
export function getDecorCoupons(params) {
  const url = decorType === 'admin'
    ? 'admin/promotion/coupons'
    : `${api.seller}/seller/promotion/coupons`
  return request({ url, method: 'get', loading: false, params })
}
